import type { FC } from 'react';
import React, { Fragment, useEffect } from 'react';
import debounce from 'lodash/debounce';

type ResizeChangeListenerProps = {
	onUpdate: () => void;
	popupRef: HTMLElement | null;
	children?: React.ReactNode;
};

export const ResizeChangeListener: FC<ResizeChangeListenerProps> = ({
	onUpdate,
	popupRef,
	children,
}) => {
	useEffect(() => {
		if (!popupRef) {
			return;
		}
		const updateWithDelay = debounce(onUpdate, 100);

		// Workaround to update popup position (by using scheduleUpdate function)
		// on any Forge App resize
		const observer = new ResizeObserver(() => {
			updateWithDelay();
		});

		observer.observe(popupRef);

		return () => {
			updateWithDelay.cancel();
			observer.disconnect();
		};
	}, [popupRef, onUpdate]);

	return <Fragment>{children}</Fragment>;
};
